export default {"src":"/hedera/_next/static/media/support_light.e010e887.svg","height":24,"width":24};